/*
 * Author M. Atoar Rahman
 * Title: Medicines Requisition Facility (Clone)
 * Description: Page for Medicines Requisition Facility (Clone for d1-preparation-2)
 * Date: 16/08/2026
 */

import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { D1FormProvider } from '../facility/d1Form2/ContextAPI';
import Index from '../facility/d1Form2/Index';
import PermissionDenied from './PermissionDenied';

export default function D1Form2() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['d1-preparation-2'] && !route_permissions['d1-preparation'])
        return <PermissionDenied />;

    return (
        <D1FormProvider>
            <Index />
        </D1FormProvider>
    );
}
